import { AvatarDesignTokens } from "@primeuix/themes/types/avatar";
import { primitiveColorTokens } from "src/assets/layout/styles/tokens/primitive";

export const avatar: AvatarDesignTokens = {
    root: {
        background: primitiveColorTokens.shade[200],
    },
};
